export default __webpack_public_path__ + "static/media/leftside.92925f34.png";